




























































































































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { Event, PerimAffects, Collab } from "@/shared/Event";
import ErrorMixin from "@/mixins/errorMixins";
import moment from "moment/moment";
import EventMixin from "@/mixins/eventMixin";
import MobileMixin from "@/mixins/mobileMixin";
import { uuid } from "vue-uuid";

@Component({
  components: {},
})
export default class AddEvent extends mixins(
  MyMixin,
  ErrorMixin,
  EventMixin,
  MobileMixin
) {
  @Prop() public myEvent!: Event;
  @Prop() public prevhierarchie!: Collab;
  public showDateChooser = false;
  public showDateChooserF = false;
  public confirmDelete = false;
  public dates: string[] = new Array();
  public typeEvent: string[] = new Array();
  public showStartTime = false;
  public showEndTime = false;
  public startTime: string = "00:00";
  public endTime: string = "23:59";
  public maxPlu = 0;
  public maxCan = 0;
  public allCanal = true;
  public allPlu = true;
  public errors = {
    dateError: false,
    designationError: false,
    eventError: false,
    pluError: false,
    canalError: false,
    tauxImpactError: false,
    typeImpactError: false,
  };
  public showCode: boolean = false;

  public pluCanRest: any = { plu: [], canal: [] };
  public pluCanAffects: any = { plu: [], canal: [] };

  public perimAffects: PerimAffects[] = new Array();

  public showNotAvailable = false;

  public mounted() {
    this.getHierarchieData();
    this.transformEvt();
    this.analyseEvt();
    this.firstDate(new Array(new Date()));
    // console.log(this.hierarchie);
  }
  /**
   * methode de création / modification d'un evenemnt
   */
  public saveEvent() {
    // console.log(this.addEvent, this.addEvent.date_fin);
    this.errors.dateError = false;
    this.errors.eventError = false;
    this.errors.canalError = false;
    this.errors.pluError = false;
    this.errors.designationError = false;
    this.errors.tauxImpactError = false;
    this.errors.typeImpactError = false;

    if (
      this.addEvent.date_debut.length >= 5 &&
      this.addEvent.date_fin.length < 5
    ) {
      this.addEvent.date_fin = this.addEvent.date_debut;
    }
    if (
      this.addEvent.id_hierarchie === "" ||
      this.addEvent.id_hierarchie === undefined
    ) {
      this.setErrorFromTxt(this.$t("pleaseSelectEvent").toString());
      this.errors.eventError = true;
      return;
    }
    if (this.pluCanRest.canal.length === 0) {
      this.setErrorFromTxt(this.$t("pleaseSelectCanal").toString());
      this.errors.canalError = true;
      return;
    }
    if (this.pluCanRest.plu.length === 0) {
      this.setErrorFromTxt(this.$t("pleaseSelectPlu").toString());
      this.errors.pluError = true;
      return;
    }
    if (this.addEvent.designation === "") {
      this.setErrorFromTxt(this.$t("pleaseEnterDesignation").toString());
      this.errors.designationError = true;
      return;
    }
    if (this.addEvent.typeImpact === "") {
      this.setErrorFromTxt(this.$t("pleaseEnterTypeImpact").toString());
      this.errors.typeImpactError = true;
      return;
    }
    if (this.addEvent.tauxImpact === null) {
      this.setErrorFromTxt(this.$t("pleaseEnterTauxImpact").toString());
      this.errors.tauxImpactError = true;
      return;
    }
    if (
      this.addEvent.date_debut.length < 5 ||
      this.addEvent.date_fin.length < 5
    ) {
      this.errors.dateError = true;
      this.setErrorFromTxt(this.$t("badStartAndEnd").toString());
      return;
    }

    if (
      moment(this.getDate(this.addEvent.date_debut)).isAfter(
        moment(this.getDate(this.addEvent.date_fin))
      )
    ) {
      // console.log(this.addEvent.date_debut, this.addEvent.date_fin);
      const buff = this.addEvent.date_debut;
      this.addEvent.date_debut = this.addEvent.date_fin;
      this.addEvent.date_fin = buff;
    }
    // console.log(this.addEvent.date_debut);
    if (this.addEvent.date_debut.length < 7) {
      this.addEvent.date_fin[5] = 0;
      this.addEvent.date_fin[6] = 0;
      this.addEvent.date_debut[5] = 0;
      this.addEvent.date_debut[6] = 0;
    }
    if (this.addEvent.$fullDay) {
      this.addEvent.date_fin[3] = 23;
      this.addEvent.date_fin[4] = 59;
    }
    // console.log(this.addEvent.couleur);

    if (this.addEvent.version < 1 && this.addEvent.uuid_evt === "") {
      // console.log("j'ajoute");
      this.addEvent.date_creation = this.dateToArr(new Date(), true);
      this.addEvent.uuid_evt = uuid.v4();
      // console.log(this.addEvent.uuid_evt.length);
      this.addEvent.utilisateur_creation = this.user.login;
      const perimResto = new PerimAffects();
      perimResto.uuid_affect = uuid.v4();
      perimResto.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
      perimResto.type = "RES";
      this.addEvent.version++;
      perimResto.valeur = this.sites[0].restaurantId;
      this.perimAffects.push(perimResto);
      if (this.allPlu) {
        const perimplu = new PerimAffects();
        perimplu.uuid_affect = uuid.v4();
        perimplu.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
        // console.log(perimplu.uuid_evt, perimplu.uuid_evt.length);
        perimplu.type = "PLU";
        perimplu.valeur = "all";
        // this.perimAffects.push(perimplu);
      } else {
        this.pluCanRest.plu.forEach((plu: any) => {
          const perimplu = new PerimAffects();
          perimplu.uuid_affect = uuid.v4();
          perimplu.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
          // console.log(perimplu.uuid_evt, perimplu.uuid_evt.length);
          perimplu.type = "PLU";
          perimplu.valeur = plu;
          this.perimAffects.push(perimplu);
        });
      }
      if (this.allCanal) {
        const perimcan = new PerimAffects();
        perimcan.uuid_affect = uuid.v4();
        perimcan.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
        // console.log(perimcan.uuid_evt, perimcan.uuid_evt.length);
        perimcan.type = "CAN";
        perimcan.valeur = "all";
        // this.perimAffects.push(perimcan);
      } else {
        this.pluCanRest.canal.forEach((plu: any) => {
          const perimcan = new PerimAffects();
          perimcan.uuid_affect = uuid.v4();
          perimcan.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
          // console.log(perimcan.uuid_evt, perimcan.uuid_evt.length);
          perimcan.type = "CAN";
          perimcan.valeur = plu;
          this.perimAffects.push(perimcan);
        });
      }
    } else {
      // console.log("je modifie");
      // this.showNotAvailable = true;
      // return;
      this.addEvent.date_modification = this.dateToArr(new Date(), true);
      this.addEvent.utilisateur_modification = this.user.login;
      this.addEvent.version++;
      this.chechUnusedPerimAffects();
    }
    // console.log(this.perimAffects);
    this.perimAffects = this.perimAffects.filter(
      (perim: PerimAffects) => perim.uuid_evt === this.addEvent.uuid_evt
    );
    const collab: Collab = new Collab(this.addEvent, this.perimAffects);
    // this.showCode = true;
    this.$emit("saveEvent", collab);
  }

  public updateDay(event: any) {
    if (event) {
      this.addEvent.date_debut[3] = 0;
      this.addEvent.date_debut[4] = 0;
      this.addEvent.date_fin[3] = 0;
      this.addEvent.date_fin[4] = 0;
    }
    this.$forceUpdate();
  }

  public updateCan() {
    if (this.allCanal) {
      this.pluCanRest.canal = new Array();
      this.pluCanRest.canal.push("all");
      this.selectAllCan();
    } else {
      this.deselectAllCan();
    }
  }

  public updatePlu() {
    if (this.allPlu) {
      this.pluCanRest.plu = new Array();
      this.pluCanRest.plu.push("all");
      this.selectAllPlu();
    } else {
      this.deselectAllPlu();
    }
    // console.log(this.pluCanRest.plu);
  }
  /**
   * methode de vérification des perimAffect pour un evenement existant
   * on supprime ceux qui ne sont plus présent (flag_suppression = true)
   * on ajoute les nouveaux
   */
  public chechUnusedPerimAffects() {
    // on cherche les perim de l'evenement à modifier
    const myPerim = this.prevhierarchie.perim_affects.filter(
      (perim: PerimAffects) =>
        perim.uuid_evt === this.addEvent.uuid_evt && !perim.flag_suppression
    );

    const newPerim = new Array();
    // on cherche les perims affects existants et on verifie si ils sont toujours associés

    // si ils sont tous selectionnés, on supprime ceux qui ne sont pas all
    if (this.allCanal) {
      console.log(this.allCanal);
      const find = myPerim.find(
        (can: any) => can.valeur === "all" && can.type === "CAN"
      );
      if (find === undefined) {
        const perimplu = new PerimAffects();
        perimplu.uuid_affect = uuid.v4();
        perimplu.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
        // console.log(perimplu.uuid_evt, perimplu.uuid_evt.length);
        perimplu.type = "CAN";
        perimplu.valeur = "all";
        // newPerim.push(perimplu);
      }
      myPerim.map((perim: PerimAffects) => {
        if (perim.type === "CAN" && perim.valeur !== "all") {
          perim.flag_suppression = true;
          this.perimAffects.push(perim);
        }
      });
    } else {
      myPerim.map((perim: PerimAffects) => {
        if (perim.type === "CAN") {
          const find = this.pluCanRest.canal.find(
            (can: any) => perim.valeur === can
          );
          // console.log(find);
          if (find === undefined) {
            perim.flag_suppression = true;
            this.perimAffects.push(perim);
          }
        }
      });
      // puis on ajoute les nouveaux selectionnés via le add !!!
      // console.log(this.pluCanRest);
      this.pluCanRest.canal.forEach((canal: any) => {
        const find = myPerim.find((pa: PerimAffects) => pa.valeur === canal);
        // console.log(find);
        if (find === undefined) {
          const perimcan = new PerimAffects();
          perimcan.uuid_affect = uuid.v4();
          perimcan.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
          // console.log(perimcan.uuid_evt, perimcan.uuid_evt.length);
          perimcan.type = "CAN";
          perimcan.valeur = canal;
          newPerim.push(perimcan);
        }
      });
    }
    // si selectionner tous est selectionné : on supprime tous les autres et on ajoute le all
    if (this.allPlu) {
      const find = myPerim.find(
        (can: any) => can.valeur === "all" && can.type === "PLU"
      );
      if (find === undefined) {
        const perimplu = new PerimAffects();
        perimplu.uuid_affect = uuid.v4();
        perimplu.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
        // console.log(perimplu.uuid_evt, perimplu.uuid_evt.length);
        perimplu.type = "PLU";
        perimplu.valeur = "all";
        // newPerim.push(perimplu);
      }
      myPerim.map((perim: PerimAffects) => {
        if (perim.type === "PLU" && perim.valeur !== "all") {
          perim.flag_suppression = true;
          this.perimAffects.push(perim);
        }
      });
    } else {
      // sinon on vérifie les perims affects existants par rapport à ceux qui n'y sont plus
      myPerim.map((perim: PerimAffects) => {
        if (perim.type === "PLU") {
          const find = this.pluCanRest.plu.find(
            (can: any) => perim.valeur === can
          );
          if (find === undefined) {
            perim.flag_suppression = true;
            // console.log("je met le perim affect à suppression true");
            this.perimAffects.push(perim);
          }
        }
      });
      // puis on ajoute les nouveaux selectionnés
      this.pluCanRest.plu.forEach((plu: any) => {
        const find = myPerim.find((pa: PerimAffects) => pa.valeur === plu);
        // console.log(find);
        if (find === undefined) {
          const perimplu = new PerimAffects();
          perimplu.uuid_affect = uuid.v4();
          perimplu.uuid_evt = (" " + this.addEvent.uuid_evt).slice(1);
          // console.log(perimplu.uuid_evt, perimplu.uuid_evt.length);
          perimplu.type = "PLU";
          perimplu.valeur = plu;
          newPerim.push(perimplu);
        }
      });
    }
    // console.log(newPerim);
    if (newPerim.length > 0) {
      this.$store.dispatch("home/addPerim", newPerim).then((response: any) => {
        // console.log(response);
      });
    }
  }

  public pretty(value: any) {
    return JSON.stringify(value, null, "\t");
  }
  /**
   * methode permettant de décocher le tout selectionner au choix d'un type
   * @param event les elements selectionnés
   * @param type le type d'element selectionné
   */
  public showMe(event: any, type: string) {
    // console.log("showMe", type, event.length ,  this.maxPlu );
    if (type === "PLU" && this.allPlu && event.length <= this.maxPlu) {
      this.allPlu = false;
    }
    if (type === "PLU" && event.length === this.maxPlu) {
      this.allPlu = true;
    }
    if (type === "CAN" && this.allCanal && event.length <= this.maxCan) {
      this.allCanal = false;
    }
    if (type === "CAN" && event.length === this.maxCan) {
      this.allCanal = true;
    }
    // console.log(this.pluCanRest.plu);
  }

  public showMeEvent(event: any) {
    // console.log(event);
    if (event.length > 1) {
      this.typeEvent = [event[1]];
    }
    this.addEvent.id_hierarchie = this.typeEvent[0];
    // console.log(this.hierarchie);
    this.hierarchie.EVENEMENT.forEach((ev: any) => {
      ev.liste.forEach((evEnfant: any) => {
        if (evEnfant.id === this.typeEvent[0]) {
          this.addEvent.typeImpact = evEnfant.typeImpactDefaut;
        }
      });
    });
    const color = this.hierarchie.EVENEMENT.find((ev: any) => {
      return ev.liste.filter(
        (evEnfant: any) => evEnfant.id_hierarchie === this.typeEvent[0]
      );
    });
    // console.log(color);
    this.addEvent.couleur = color && color.couleur ? color.couleur : "red";
    // console.log(this.addEvent.couleur);
  }
  /**
   * methode de suppression d'un evenement
   */
  public deleteEvt() {
    this.$emit("deleteEvent", this.addEvent);
  }
  /**
   * methode de fermuture du dialogue
   */
  public closeDialEvent() {
    this.pluCanRest.plu = new Array();
    this.pluCanRest.canal = new Array();
    this.$emit("closeDialEvent");
    this.confirmDelete = false;
  }

  public firstDate(date: any) {
    // console.log(date);
    this.addEvent.date_debut = this.dateToArr(new Date(date[0]), false);
    this.addEvent.date_fin = this.dateToArr(new Date(date[0]), false);
    // console.log(this.addEvent.date_debut);
  }
  /**
   * méthode de maj de la date
   */
  public updateDate(date: string[]) {
    if (moment(this.dates[0]).isAfter(moment(this.dates[1]))) {
      const buff = this.dates[0];
      this.dates[0] = this.dates[1];
      this.dates[1] = buff;
    }
    if (this.addEvent.$fullDay) {
      this.addEvent.date_debut = this.dateToArr(new Date(date[0]), false);
      this.addEvent.date_fin = this.dateToArr(new Date(date[1]), false);
    } else {
      this.setDateAndTime();
    }

    this.showDateChooserF = false;
    this.showDateChooser = false;
  }
  /**
   * recupération du nom de l'evenement national (filtré pour ne plus apparaitre pour les locaux)
   */
  public getEventNatType() {
    let hierarchie = new Array();
    if (this.hierarchie.EVENEMENTNAT.length > 0) {
      hierarchie = this.hierarchie.EVENEMENTNAT.filter((ev: any) => {
        // console.log(ev.id_hierarchie);
        return ev.id_hierarchie === this.addEvent.id_hierarchie;
      });
    }
    // console.log(hierarchie);
    return hierarchie.length > 0
      ? hierarchie[0].id_hierarchie + " " + hierarchie[0].designation_hierarchie
      : "INCONNU";
  }

  public analyseEvt() {
    this.errors = {
      dateError: false,
      designationError: false,
      eventError: false,
      pluError: false,
      canalError: false,
      tauxImpactError: false,
      typeImpactError: false,
    };
    if (this.addEvent.uuid_evt === "") {
      this.pluCanRest.plu = [];
      this.pluCanRest.canal = [];
      this.allCanal = true;
      this.allPlu = true;
      this.typeEvent = new Array();

      this.selectAllPlu();
      this.selectAllCan();
    } else {
      this.pluCanRest.plu = [];
      this.pluCanRest.canal = [];

      if (this.addEvent.date_creation.length === 0) {
        this.addEvent.date_debut = this.dateToArr(new Date(), false);
        this.addEvent.date_fin = this.dateToArr(new Date(), false);
        this.addEvent.$fullDay = true;
      } else {
        // console.log(this.addEvent.date_debut, this.addEvent.date_creation[3]);
        this.dates[0] = moment(this.getDate(this.addEvent.date_debut)).format(
          "YYYY-MM-DD"
        );
        this.dates[1] = moment(this.getDate(this.addEvent.date_fin)).format(
          "YYYY-MM-DD"
        );
        this.addEvent.$fullDay =
          this.addEvent.date_debut[3] === 0 ? true : false;
        this.typeEvent = [this.addEvent.id_hierarchie];
        const myPerim = this.prevhierarchie.perim_affects.filter(
          (perim: PerimAffects) =>
            perim.uuid_evt === this.addEvent.uuid_evt && !perim.flag_suppression
        );
        // console.log(myPerim);
        myPerim.map((perim: PerimAffects) => {
          if (perim.type === "CAN") {
            this.pluCanRest.canal.push(perim.valeur);
          } else if (perim.type === "PLU") {
            this.pluCanRest.plu.push(perim.valeur);
          }
        });
      }
      this.allCanal = this.pluCanRest.canal.length === 0;
      this.allPlu = this.pluCanRest.plu.length === 0;
      // console.log(this.pluCanRest.canal.length);
      if (this.allPlu) {
        this.selectAllPlu();
      }
      if (this.allCanal) {
        this.selectAllCan();
      }
    }
  }

  public handleOpenOrClose(openNodesArray: any[]) {
    // console.log(openNodesArray);
    // console.log(this.typeEvent, this.addEvent.id_hierarchie);
    /*if (this.hierarchie["EVENEMENT"] !== undefined) {
      this.hierarchie["EVENEMENT"].map((evt: any) => {
      // console.log(evt.libelle);

      const elem = evt.liste.find((ev: any) =>

          ev.id.includes(this.addEvent.id_hierarchie)
      );
      if (elem !== undefined) {
          openNodesArray.push(evt.id);
      }
      // console.log(elem);
      });
    }
    console.log(openNodesArray); */
    return openNodesArray;
  }
  /**
   * reload on change
   */
  @Watch("myEvent", { immediate: true, deep: false })
  public onEvtChanged({ value, oldValue }: { value: any; oldValue: any }) {
    this.getHierarchieData();
    this.transformEvt();
    this.analyseEvt();
  }

  public updateTime(time: any, type: number) {
    this.setDateAndTime();
    // console.log("******* end", this.endTime, "start", this.startTime);
    this.showEndTime = false;
    this.showStartTime = false;
    this.$forceUpdate();
  }

  public getTypes(type: string) {
    return this.hierarchie[type];
  }
  /**
   * methode de transformation du timestamp en date affichage
   */
  public afficheDates() {
    const debut = this.getDate(this.addEvent.date_debut);
    const fin = this.getDate(this.addEvent.date_fin);
    let FORMAT = "DD/MM/YYYY";
    if (this.addEvent.source === "NAT") {
      FORMAT = "DD/MM/YYYY HH:mm";
    }
    const date =
      this.$t("from").toString() +
      " " +
      moment(debut).format(FORMAT) +
      " " +
      this.$t("to").toString() +
      " " +
      moment(fin).format(FORMAT);
    return date;
  }

  /**
   * methode de selection de l'ensemble des plu
   */
  private selectAllPlu() {
    this.hierarchie.PLU.map((can: any) => this.pluCanRest.plu.push(can.id));
    const scope = this;
    setTimeout(() => {
      // console.log(scope.pluCanRest)
      this.allPlu = true;
      scope.maxPlu = scope.pluCanRest.plu.length;
    }, 50);
  }
  /**
   * methode désélection de l'ensemble des plu
   */
  private deselectAllPlu() {
    this.pluCanRest.plu = [];
    const scope = this;

    setTimeout(() => {
      scope.maxPlu = 0;
      this.allPlu = false;
    }, 50);
  }

  /**
   * methode de selection de l'ensemble des canaux de vente
   */
  private selectAllCan() {
    this.hierarchie.CANAL.map((can: any) => this.pluCanRest.canal.push(can.id));
    const scope = this;
    setTimeout(() => {
      scope.maxCan = scope.pluCanRest.canal.length;
      this.allCanal = true;
    }, 0);
  }
  /**
   * methode désélection de l'ensemble des canaux de vente
   */
  private deselectAllCan() {
    this.pluCanRest.canal = [];
    const scope = this;
    setTimeout(() => {
      scope.maxCan = 0;
      this.allCanal = false;
    }, 0);
  }
  /**
   * methode de maj de la date et de l'heure
   */
  private setDateAndTime() {
    let times: string[] = new Array();
    let times2: string[] = new Array();
    if (this.startTime !== "") {
      times = this.startTime.split(":");
      const start = moment(this.dates[0])
        .hour(parseInt(times[0]))
        .minutes(parseInt(times[1]));
      this.addEvent.date_debut = this.dateToArr(start.toDate(), true);
    }
    if (this.endTime !== "") {
      times2 = this.endTime.split(":");
      this.addEvent.date_fin = this.dateToArr(
        moment(this.dates[1])
          .hour(parseInt(times2[0]))
          .minutes(parseInt(times2[1]))
          .toDate(),
        true
      );
    }
  }
  /**
   * methode de transformation des dates et heure de début et de fin des evenemnts
   */
  private transformEvt() {
    this.dates = [
      moment(this.getDate(this.addEvent.date_debut)).format("YYYY-MM-DD"),
      moment(this.getDate(this.addEvent.date_fin)).format("YYYY-MM-DD"),
    ];
    this.startTime = moment(this.getDate(this.addEvent.date_debut)).format(
      "HH:mm"
    );
    this.endTime = moment(this.getDate(this.addEvent.date_fin)).format("HH:mm");
  }
  /**
   * transform hierarche et canal / plu
   */
  private getHierarchieData() {
    this.hierarchie = this.transformHierarchie(this.prevhierarchie);
  }

  get addEvent(): Event {
    return this.myEvent;
  }

  set addEvent(evt: Event) {
    this.addEvent = evt;
  }

  get user() {
    return this.$store.getters["login/user"];
  }

  get sites() {
    return this.$store.getters["login/sites"];
  }
}
